import styled from 'styled-components';

export const ConsultStrip = styled.div`
  display: flex;
  background-color: ${(props) => (props.color ? props.color : '#e6f2f1')};
  width: 100%;
  align-items: center;
  @media (min-width: 768px) {
    justify-content: ${(props) => (props.centerFlex ? 'center' : 'flex-start')};
  }

  .marqueeContainer {
    padding-left: ${(props) => (props.article ? '1em' : '')};
    flex-basis: ${(props) =>
      props.bookingDone ? '100%' : props?.installStrip ? '80%' : '60%'};
    @media (min-width: 768px) {
      flex-basis: ${(props) => (props.bookingDone ? '100%' : '50%')};
    }
  }

  &.assessmentStrip {
    justify-content: space-between;
    @media (min-width: 768px) {
      justify-content: center;
      column-gap: 40px;
    }
  }

  .bookingForm {
    font-size: 12px;
    font-weight: ${(props) => (props.isGlobalStrip ? 500 : 600)};
    color: ${(props) => (props.buttonColor ? props.buttonColor : '#ef4e5e')};
    display: flex;
    flex-basis: ${(props) =>
      props.isGlobalStrip && props.userTypeBasis ? '100%' : '50%'};
    align-items: center;
    justify-content: center;
    height: 32px;

    img {
      margin-left: 2px;
      width: ${(props) =>
        props.userTypeBasis ? '3%' : props.isGlobalStrip ? '7%' : '13%'};
    }

    @media (min-width: 768px) {
      flex-basis: 16%;
      margin-left: 8px;
      cursor: pointer;
      img {
        width: ${(props) => (props.isGlobalStrip ? '5%' : '13%')};
      }
    }
  }

  .leftText {
    font-size: 14px;
    // font-weight: 500;
    color: #fff;
    flex-shrink: 0;
    padding-left: 10px;
  }

  .lowOpacity {
    opacity: 0.4;
  }

  cursor: pointer;
  @media (max-width: 720px) {
    cursor: none;
  }

  position: fixed;
  overflow: hidden;
  z-index: 99;

  &.popupCta {
    padding: 16px;
    font-size: 20px;
    font-size: 20px;

    span.ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      animation: ripple 600ms linear;
      background-color: hsl(0deg, 0%, 0%, 18%);
      z-index: 10;
    }

    @keyframes ripple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  }

  &.shimmer {
    span {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.02) 1%,
        rgba(255, 255, 255, 0.2) 10%,
        rgba(255, 255, 255, 0.5) 40%,
        rgba(255, 255, 255, 0.85) 60%,
        rgba(255, 255, 255, 0.85) 70%,
        rgba(255, 255, 255, 0.85) 71%,
        rgba(255, 255, 255, 0) 100%
      );
      width: 20%;
      height: 100%;
      animation: move_continue 2s;
      animation-iteration-count: infinite;
      animation-delay: 1s;
    }

    @keyframes move_continue {
      0% {
        left: 0;
        opacity: 0.1;
      }
      5% {
        opacity: 0.2;
      }
      48% {
        opacity: 0.3;
      }
      80% {
        opacity: 0.1;
      }
      100% {
        left: 82%;
      }
    }
  }
`;
export const StripText = styled.p`
  text-align: center;
  display: flex;
  justify-content: center;
  padding: 8px 0;
  font-weight: 500;
  align-items: center;
  column-gap: 4px;
  font-size: 14px;

  img {
    width: 14px;
    height: 14px;
    opacity: 0.9;
  }

  &.lowOpacity {
    opacity: 0.4;
  }

  color: white;
  padding-right: 10px;

  &.botStrip {
    width: 100%;
    font-size: 16px;
    padding: 12px;
    font-size: 18px;
  }

  &.botStrip2 {
    width: 100%;
    font-size: 20px;
    font-weight: 600;
  }
`;
export const BottomStickyStrip = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
`;

export const StickyDiv = styled.div`
  position: ${(props) =>
    props.stickyOnly ? 'fixed' : props.pdp ? 'relative' : 'fixed'};
  top: ${(props) =>
    props.chips
      ? '96px'
      : props.showHeader == '-56px'
        ? '0px'
        : props.isDiaperSku
          ? '119px'
          : props.pdp
            ? '66px'
            : props.sticky
              ? '0px'
              : '64px'};
  width: 100%;
  z-index: ${(props) => (props.showPopup ? '1' : props.pdp ? '991' : '99')};
  @media (min-width: 768px) {
    position: fixed;
    top: ${(props) => (props.chips ? '122px' : props.sticky ? '0px' : '90px')};
  }
  @media (max-width: 720px) {
    position: ${(props) => (props.isForJoyfulPage ? 'relative' : 'fixed')};
    top: ${(props) => (props.isForJoyfulPage ? '15px' : '0px')};
  }
  cursor: ${(props) => (props.redirectionUrl ? 'pointer' : 'default')};
`;
export const MobileDevice = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
